import { render } from "./TileButton.vue?vue&type=template&id=6d961599&scoped=true"
import script from "./TileButton.vue?vue&type=script&lang=js"
export * from "./TileButton.vue?vue&type=script&lang=js"

import "./TileButton.vue?vue&type=style&index=0&id=6d961599&scoped=true&lang=scss"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d961599"]])

export default __exports__